import template from "./claims-list-item.html"

(function ($, ko) {
    ko.components.register('claims-list-item', {
        template: template,
        viewModel: {
            createViewModel: function (params, componentInfo, widgetInfo) {
                return new ClaimsListItem(params, widgetInfo.updateHeight);
            }
        }
    });

    function ClaimsListItem (params, updateHeight) {
        let claim = params.claim;
        let reloadListCallback = params.reloadListCallback;
        let accountsList = params.accountsList;
        let isDirectRequest = params.accountsSettings.isDirectRequest;
        let anyHsaOnly = params.accountsSettings.anyHsaOnly;
        let anyNonHsaOnly = params.accountsSettings.anyNonHsaOnly;
        this.baseParams = params;

        const urlParams = {
            page: $.cdh.helper.urlParam('page')
        }
        this.forceAddReceipt = urlParams.page === 'AddReceipt';
        this.openAddReceiptPopup = ko.observable(this.forceAddReceipt);
        this.isAiAdjudicationSettingsLoading = ko.observable(false);
        
        $.extend(true, this, claim);
        this.sourceTranDesc = `Claims List. ItemId: ${this.ItemId}, Type: ${this.Type}`;
        
        this.anyHsaOnly = anyHsaOnly;
        this.anyNonHsaOnly = anyNonHsaOnly;
        this.requestReimbursementBuilder = ko.observable();
        this.requestReimbursementTemplate = ko.observable();
        this.isDirectRequest = isDirectRequest;
        this.reloadListCallback = reloadListCallback;

        this.medicalDetails = null;
        this.fxClaimDetails = null;
        
        this.ReceiptsCount = ko.observable(claim.ReceiptsCount);
        this.Receipts = ko.observableArray(claim.Receipts);
        this.PatientId = ko.observable('');
        this.PatientName = ko.observable('');
        this.open = ko.observable(params.expand);
        this.denialReason = ko.observable(null);
        this.isMarkClaim = ko.observable(false);
        
        this.isEnabledPortal = $.cdh.tpa.useExpensePortal;
        this.accountsList = ko.pureComputed(function () {
            return ko.unwrap(accountsList) || [];
        });
        this.isServiceStartDateWithinAnyActivePlan = ko.pureComputed(function () {
            if (!this.ServiceStartDate) {
                return false;
            }

            var serviceStartDate = moment.utc(this.ServiceStartDate);
            if (!serviceStartDate.isValid()) {
                return false;
            }

            return this.accountsList().some(function (account) {
                if (!account ||
                    !account.PlanStartDate ||
                    !account.LastDayToSubmitClaim) {
                    return false;
                }

                var planStartDate = moment.utc(account.PlanStartDate);
                var submitClaimsLastDate = moment.utc(account.LastDayToSubmitClaim);

                if (!planStartDate.isValid() || !submitClaimsLastDate.isValid()) {
                    return false;
                }

                return serviceStartDate.isSameOrAfter(planStartDate, 'day') &&
                    serviceStartDate.isSameOrBefore(submitClaimsLastDate, 'day');
            });
        }, this);
        
        this.shortAccountDescription = claim.AccountTypeDescription && claim.AccountTypeDescription.length > 30 ? 
            claim.AccountTypeDescription.substr(0, 30) + '...' : 
            claim.AccountTypeDescription;

        this.translatedStatus = ko.computed(function () {
            return claim.TranslatedStatus;
        });

        this.translatedType = ko.computed(function () {
            return claim.TranslatedType
        });

        this.color = ko.pureComputed(function () {
                var color;
                if (this.Actionable()) {
                    color = 'color5';
                } else {
                    color = this.baseColor();
                }
                return color;
            },
            this);

        this.baseColor = ko.pureComputed(function () {
                var c;
                var tp = this.EOBType;
                var status = this.Status();

                if ((tp == 'Claim' || tp == 'MedicalClaim') && (status == 'Submitted' || status == 'Deductible' || status == 'Approved' || status == 'Offset' || status == 'Reprocessed'))
                    c = 'color';
                else if (tp == 'Claim' || tp == 'MedicalClaim' && status.indexOf('Denied') < 0) {
                    c = 'color1';
                } else if (tp == 'Expense' && status == 'Submitted' || status.indexOf('Paid') == 0)
                    c = 'color';
                else if (tp == 'Expense') {
                    c = 'color6';
                } else if (tp == 'ExpenseGroup' || tp == 'FxClaim') {
                    if (status.indexOf('Denied') > -1) {
                        c = 'color3';
                    } else {
                        c = 'color';
                    }
                } else {
                    c = status.indexOf('Paid') > -1 ||
                    status.indexOf('Approved') > -1 ||
                    status.indexOf('OnHold') > -1 ||
                    status.indexOf('On Hold') > -1 ||
                    status.indexOf('Reprocessed') > -1
                        ? 'color'
                        : 'color3';

                    if (status.indexOf('Denied') > -1)
                        c = 'color3';
                }
                return c;
            },
            this);

        this.CanRequestReimbursement = ko.observable(false);
        var eobType = claim.EOBType;
        if (eobType == "Transaction") {
            var details = new $.cdh.get.transaction.details(claim.EOBExtra);
            var newDesc;
            if (claim.Description !== null && claim.Description !== '' && claim.Description !== undefined && claim.Description.startsWith("medical<br>")) {
                newDesc = claim.Description.replace("medical<br>", "");
                this.Description = newDesc;
            }
            this.details = details;
            this.details.Denied = ko.observable(claim.IsDenied);
            details.data.subscribe(function (transaction) {
                var receipts = transaction.Receipts;
                if (receipts) {
                    this.ReceiptsCount(receipts.length);
                    this.Receipts(receipts);
                }

                if (this.Status().indexOf('Denied') > -1 && transaction.ErrorDesc && transaction.ErrorDesc.length > 0){
                    this.denialReason (transaction.ErrorDesc);
                }
            }, this);

        } else {
            this.details = null;
            if ((eobType == 'Expense' || eobType == 'ExpenseGroup' || eobType == 'FxClaim') && claim.EOBAction != null) {
                if($.cdh.employee.canRequestReimbursement()) {
                    this.CanRequestReimbursement(true);
                    
                    this.goToPortal = () => {


                        let portalParam = '';
                        switch(eobType) {
                            case 'FxClaim':
                                portalParam = `fxClaimId=${claim.TrackingNumber}`;
                                break;
                            case 'ExpenseGroup':
                                portalParam = `tcClaimId=${claim.TrackingNumber}`;
                                break;
                            case 'Expense':
                                portalParam = `expenseKey=${claim.ExpenseKey}&originCde=${claim.OriginCde}`;
                                break;
                        }

                        document.location.href = $.cdh.routes.predefined.claims.portal + '?' + portalParam;
                    };
                }

                if (eobType == 'FxClaim') {
                    this.requestReimbursementBuilder = function () {
                        return new $.cdh.models.SubmitClaimWidgetModel(this.reloadListCallback, $.noop, this);
                    }.bind(this);
                    this.requestReimbursementTemplate = function () {
                        return 'template-claim-widget-view';
                    }.bind(this);

                } else if (!this.isDirectRequest()) {
                    this.requestReimbursementBuilder = function () {
                        return new $.cdh.models.RequestReimbursementType(this.reloadListCallback, $.noop, this, true);
                    }.bind(this);
                    this.requestReimbursementTemplate = function () {
                        return 'template-claims-request-reimbursement-type';
                    }.bind(this);

                } else {
                    if (this.anyHsaOnly()) {
                        this.requestReimbursementBuilder = function () {
                            return new $.cdh.models.PaymentsAddPopup(0, this.reloadListCallback, this, $.noop, true);
                        }.bind(this);
                        this.requestReimbursementTemplate = function () {
                            return 'template-payments-add-popup';
                        }.bind(this);
                    } else if (this.anyNonHsaOnly()) {
                        this.requestReimbursementBuilder = function () {
                            return new $.cdh.models.SubmitClaimWidgetModel(this.reloadListCallback, $.noop, this);
                        }.bind(this);
                        this.requestReimbursementTemplate = function () {
                            return 'template-claim-widget-view';
                        }.bind(this);
                    }
                }
            }
        }
        if (eobType === "MedicalClaim") {
            var medicalDetails = new $.cdh.get.claims.medicalDetails();
            this.medicalDetails = medicalDetails;
        }
        else if (eobType == "FxClaim") {
            var fxClaimDetails = new $.cdh.get.claims.fxDetails();
            this.fxClaimDetails = fxClaimDetails;
        }
        recalcWidgetsHeights();

        this.isPaidOutOfPocket = ko.observable(this.Status() === "Paid Out-Of-Pocket");

        const self = this;

        this.disable = ko.observable(false);

        function setPaidOutOfPocked() {
            $.cdh.helper.alert2({
                title: $.cdh.customLabels.markAsPaidOption,
                message: $.cdh.customLabels.markAsPaidOptionPopupText,
                cancelVisible: true,
                okCssClass: 'button-subm button-width-auto min-width-standard',
                okText: $.cdh.customLabels.markAsPaidOption,
                cancelText: $.cdh.languageConstant.getConstant('button.cancel'),
                buttonsBlockCssClass: 'popup_buttons--flex',
                okCallback: function () {
                    self.disable(true);
                    new $.cdh.post.claims.fxClaimMarkAsPaid()
                        .load({externalClaimId: self.EOBExtra.ExternalClaimId})
                        .done(function () {
                            self.disable(false);
                            self.reloadListCallback();
                        });
                }
            });
        }

        function reversePaidOutOfPocket() {
            $.cdh.helper.alert2({
                title: $.cdh.customLabels.reverseMarkAsPaidOption,
                message: $.cdh.customLabels.reverseMarkAsPaidOptionPopupText,
                cancelVisible: true,
                okText: "Continue",
                okCallback: function () {
                    // TODO: make it possible to display popup from code
                    $('#claim-details-button-' + self.EOBExtra.ExternalClaimId).click();
                }
            });
        }

        this.setPaidOutOfPocket = function (data, event) {
            event.stopPropagation();
            if (self.isPaidOutOfPocket()) {
                reversePaidOutOfPocket();
            } else {
                setPaidOutOfPocked();
            }
        };

        function isTooltipClick(event) {
            if (!event || !event.target) {
                return false;
            }
            return $(event.target).hasClass('js-tooltip');
        }

        this.onToggle = function (data, event) {

            if(isTooltipClick(event)) return;

            var newOpen = !this.open();

            var details = this.details;
            var medicalDetails = this.medicalDetails;
            var fxClaimDetails = this.fxClaimDetails;

            this.open(newOpen);
            if (newOpen) {
                if (details != null && !details.hasData() && !details.isLoading()) {
                    details.load();
                }
                if (this.TrackingNumber) {
                    $.cdh.helper.setUrlParam('claimId', this.TrackingNumber);
                }else{
                    $.cdh.helper.deleteUrlParam('claimId');
                }
            }else{
                $.cdh.helper.deleteUrlParam('claimId');
            }

            if (this.EOBType == 'FxClaim') {
                if (newOpen && fxClaimDetails != null && !fxClaimDetails.hasData() && !fxClaimDetails.isLoading()) {
                    fxClaimDetails.load({ externalClaimId: this.EOBExtra.ExternalClaimId });
                    fxClaimDetails.data.subscribe(function(fx) {
                            var total = fx.Total;
                            if (total != null) {
                                this.PatientId = total.PatientId;
                                this.PatientName = total.PatientName;
                            }

                        }.bind(this),
                        this);
                }
            }
            else if (this.EOBType == 'MedicalClaim') {
                if (newOpen && medicalDetails != null && !medicalDetails.hasData() && !medicalDetails.isLoading()) {
                    medicalDetails.load({ transactionKeys: this.EOBExtra });
                    medicalDetails.data.subscribe(function(eob) {
                            var receipts = eob.Transactions[0].Receipts;
                            if (receipts) {
                                this.ReceiptsCount(receipts.length);
                                this.Receipts(receipts);
                            }
                        }.bind(this),
                        this);
                }
            }
        recalcWidgetsHeights();
        }.bind(this);

        this.itemKeyDownHandler = function (data, event) {
            if (event.keyCode === 13 || event.keyCode === 32) {
                this.onToggle(data, event);

                return false;
            }

            return true;
        };

        this.receipt = function (r) {
            return $.cdh.routes.receipts.image.get(r.FileKey);
        }.bind(this);

        this.onReceipt = function (r, event) {
            event.preventDefault();
            event.stopPropagation();
            const self = this;
            if ($.cdh.isMobile) {
                $.cdh.helper.showFancyboxLoader();
                $.ajax(event.target.href)
                    .done(function(response, status, xhr) {
                        $.cdh.helper.hideFancyboxLoader();
                        var contentType = xhr.getResponseHeader('content-type');
                        if (contentType.search('pdf') != -1) {
                            var urlText = '/Scripts/pdf-viewer-js/ViewerJs/index.html#' + event.target.href;
                            $.cdh.helper.showPdfViwer(urlText);
                        }
                        if (contentType.search('image') != -1) {
                            openFancybox(event.target.href, 'image');
                        }
                        if (contentType.search('pdf') == -1 && contentType.search('image') == -1) {
                            window.location.href = event.target.href;
                        }
                    });
            } else {
                window.open(this.receipt(r));
            }
        }.bind(this);

        this.labelButton = ko.pureComputed(function () {
            return this.isMarkClaim() ? 'Updating...' : 'Mark claim as fully paid out-of-pocket';
        }, this);
        this.showRequestReimbursementButton = ko.pureComputed(function () {
            return this.isServiceStartDateWithinAnyActivePlan();
        }, this);

        this.updateRequest = new $.cdh.post.claims.update();

        this.fullPaidOutOfPocket = function () {
            this.isMarkClaim(true);
            var details = new $.cdh.get.claims.fxDetails();
            details.load({externalClaimId: this.EOBExtra.ExternalClaimId});
            details.data.subscribe(function (fx) {
                var updates = [];
                $.each(fx.Transactions, function (i, t) {
                    updates.push({ClaimLine: t.ClaimLine, Amount: t.RemainingResponsibilityAmount});
                });

                var updateModel = {
                    ExternalClaimId: this.EOBExtra.ExternalClaimId,
                    OutOfPocketAmounts: updates
                };

                this.updateRequest
                    .load(updateModel)
                    .done(function (success) {
                        this.reloadListCallback();
                    }.bind(this))
                    .fail(function () {
                    }.bind(this));
            }.bind(this))

        }.bind(this);

        this.faxCoverUrl = $.cdh.routes.claims.downloadFaxCover({trackingNumber: this.TrackingNumber, pdf: true});
        
        this.open.subscribe(updateHeight);
        this.close = params.closeFunc || function () {};

        this.syncItem = ko.observable().syncWith($.cdh.topics.claims.requiredAttentionItems, true);
        
        this.syncItem.subscribe(function () {
            if (this.syncItem() !== undefined) {
                if ((this.syncItem().isClaim && this.ClaimKey === this.syncItem().claimKey) ||
                    (!this.syncItem().isClaim && this.TransactionId && this.TransactionId === this.syncItem().transactionId)) {
                    this.Status(this.syncItem().itemStatus);
                    this.ReceiptsCount(this.syncItem().receiptsCount);
                    this.Actionable(false);
                    this.Receipts(this.syncItem().receipts);
                }
            }
        }.bind(this));

        this.successCallback = () => {
            $.cdh.helper.deleteUrlParam('page');
        };

        this.openLegacyAddReceiptPopup = function () {
            this.openAddReceiptPopup(false);
            this.openAddReceiptPopup(true);
        }.bind(this);

        this.getAddReceiptTransactionContext = function () {
            const key = this.EOBExtra;
            const typeValue = (this.Type || "").toString().toLowerCase().trim();
            const isCardType = typeValue === 'card' || this.TransactionCode === 3;
            const isSupportedEobType = this.EOBType === 'Transaction' || this.EOBType === 'Claim';

            if (isSupportedEobType && isCardType && key && key.Id && key.SettlementDate && key.SeqNumber !== undefined && key.SeqNumber !== null) {
                return {
                    transactionId: key.Id,
                    settlementDate: key.SettlementDate,
                    sequenceNumber: key.SeqNumber
                };
            }

            return null;
        }.bind(this);

        this.getAddReceiptMfeUrl = function (context) {
            const query = $.param({
                source: "claims",
                transactionId: context.transactionId,
                sequenceNumber: context.sequenceNumber,
                settlementDate: context.settlementDate,
                accountId: this.AccountKey
            });

            return `${$.cdh.routes.predefined.mfe.addReceipt}?${query}`;
        }.bind(this);

        this.onAddReceiptClick = function (data, event) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            const context = this.getAddReceiptTransactionContext();
            if (!context) {
                this.openLegacyAddReceiptPopup();
                return false;
            }

            if (this.isAiAdjudicationSettingsLoading()) {
                return false;
            }

            this.isAiAdjudicationSettingsLoading(true);

            $.ajax({
                url: $.cdh.routes.transactions.getAiAdjudicationSettings({
                    transactionId: context.transactionId,
                    sequenceNumber: context.sequenceNumber,
                    settlementDate: context.settlementDate
                }),
                method: 'GET'
            }).done(function (response) {
                let isAiEnabled = response && response.Data && response.Data.IsAIAdjudicationEnabled === true;

                if (isAiEnabled) {
                    window.location.href = this.getAddReceiptMfeUrl(context);
                    return;
                }

                this.openLegacyAddReceiptPopup();
            }.bind(this)).fail(function () {
                this.openLegacyAddReceiptPopup();
            }.bind(this)).always(function () {
                this.isAiAdjudicationSettingsLoading(false);
            }.bind(this));

            return false;
        }.bind(this);
    }
    
})(jQuery, ko);
